import { render, staticRenderFns } from "./sixRecommend.vue?vue&type=template&id=c79c63be&scoped=true&"
import script from "./sixRecommend.vue?vue&type=script&lang=js&"
export * from "./sixRecommend.vue?vue&type=script&lang=js&"
import style0 from "./sixRecommend.vue?vue&type=style&index=0&id=c79c63be&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79c63be",
  null
  
)

export default component.exports